// Operaciones locales sobre imágenes (rotación / recorte). Nunca modifican el original.
const loadImage = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("image_load_failed"));
    img.src = url;
  });

const toDataUrl = (canvas) => {
  try {
    return canvas.toDataURL("image/jpeg", 0.92);
  } catch {
    throw new Error("canvas_tainted");
  }
};

export const rotateImage = async (url) => {
  const img = await loadImage(url);
  const c = document.createElement("canvas");
  c.width = img.naturalHeight;
  c.height = img.naturalWidth;
  const ctx = c.getContext("2d");
  ctx.translate(c.width / 2, c.height / 2);
  ctx.rotate(Math.PI / 2);
  ctx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
  return { url: toDataUrl(c), width: c.width, height: c.height };
};

export const cropImage = async (url, ratio) => {
  const [rw, rh] = ratio.split(":").map(Number);
  const img = await loadImage(url);
  const W = img.naturalWidth, H = img.naturalHeight;
  let w = W, h = Math.round((W * rh) / rw);
  if (h > H) { h = H; w = Math.round((H * rw) / rh); }
  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  c.getContext("2d").drawImage(img, (W - w) / 2, (H - h) / 2, w, h, 0, 0, w, h);
  return { url: toDataUrl(c), width: w, height: h };
};
